module.exports = __webpack_public_path__ + "img/shop-register-finish.58b856f7.png";